import type { Testimonial } from '../lib/testimonials';

export function TestimonialCard({ item }: { item: Testimonial }) {
  return (
    <blockquote className="testimonial-card soft-panel">
      <p className="testimonial-quote">“{item.quote}”</p>
      <footer className="testimonial-by">
        <cite>{item.name}</cite>
        {item.relation ? <span className="testimonial-rel">{item.relation}</span> : null}
      </footer>
    </blockquote>
  );
}
